'use es6';

(function () {
  const ERROR_PREFIX = '[custom-quick-fetch] Early request not found';
  let earlyRequests = {};
  function addClientTimeout(url, timeout) {
    const queryString = url.indexOf('?') > -1 ? '&clienttimeout=' : '?clienttimeout=';
    if (!timeout || url.indexOf('clienttimeout=') > -1) {
      return url;
    }
    return url + queryString + timeout;
  }
  function getRequestStateByName(name) {
    // eslint-disable-next-line no-prototype-builtins
    if (earlyRequests.hasOwnProperty(name)) {
      return earlyRequests[name];
    }
    return null;
  }
  function removeEarlyRequest(name) {
    // eslint-disable-next-line no-prototype-builtins
    if (earlyRequests.hasOwnProperty(name)) {
      delete earlyRequests[name];
    }
  }
  function clearAllRequests() {
    earlyRequests = {};
  }
  function requestSuccess(name, response) {
    // eslint-disable-next-line no-prototype-builtins
    if (!earlyRequests.hasOwnProperty(name)) {
      console.error(ERROR_PREFIX, name, response);
      return;
    }
    earlyRequests[name].finished = true;
    earlyRequests[name].data = response;
    earlyRequests[name].whenFinishedCallbacks.forEach(cb => {
      cb(response);
    });
  }
  function requestError(name, statusCode, xhr) {
    // eslint-disable-next-line no-prototype-builtins
    if (!earlyRequests.hasOwnProperty(name)) {
      console.error(ERROR_PREFIX, name, statusCode, xhr);
      return;
    }
    earlyRequests[name].error = true;
    earlyRequests[name].errorStatus = statusCode;
    earlyRequests[name].onErrorCallbacks.forEach(cb => {
      cb(xhr, statusCode);
    });
  }
  function makeEarlyRequest(name, ajaxOptions) {
    // eslint-disable-next-line no-prototype-builtins
    if (earlyRequests.hasOwnProperty(name)) {
      return;
    }
    const request = new XMLHttpRequest();
    request.open(ajaxOptions.type ? ajaxOptions.type : 'GET', addClientTimeout(ajaxOptions.url, ajaxOptions.timeout), true);
    // eslint-disable-next-line no-prototype-builtins
    request.withCredentials = ajaxOptions.hasOwnProperty('withCredentials') ? !!ajaxOptions.withCredentials : true;
    if (ajaxOptions.timeout != null) {
      request.timeout = ajaxOptions.timeout;
    }
    request.addEventListener('load', () => {
      let resp;
      if (200 <= request.status && request.status < 400) {
        resp = request.responseText;
        if (ajaxOptions.dataType === 'json') {
          try {
            resp = JSON.parse(resp);
          } catch (e) {
            requestError(name, 'Parsing error. Response is not valid JSON', request);
            return;
          }
        }
        requestSuccess(name, resp);
        return;
      }
      requestError(name, `Network request failed. Status: ${request.status}`, request);
    });
    request.addEventListener('error', () => {
      requestError(name, 'Network request failed', request);
    });
    request.addEventListener('timeout', () => {
      requestError(name, 'timeout', request);
    });
    request.setRequestHeader('Accept', 'application/json, text/javascript, */*; q=0.01');
    if (ajaxOptions.extraHeaders && ajaxOptions.extraHeaders.length) {
      ajaxOptions.extraHeaders.forEach(headerObj => {
        request.setRequestHeader(headerObj.header, headerObj.value);
      });
    }
    if (ajaxOptions.contentType) {
      request.setRequestHeader('Content-type', ajaxOptions.contentType);
    }
    earlyRequests[name] = {
      finished: false,
      error: false,
      errorStatus: '',
      whenFinishedCallbacks: ajaxOptions.whenFinished ? [ajaxOptions.whenFinished] : [],
      onErrorCallbacks: ajaxOptions.onError ? [ajaxOptions.onError] : [],
      whenFinished(cb) {
        if (this.finished) {
          cb(this.data);
        } else {
          this.whenFinishedCallbacks.push(cb);
        }
      },
      onError(cb) {
        if (this.error) {
          cb(this.request, this.errorStatus);
        } else {
          this.onErrorCallbacks.push(cb);
        }
      },
      request
    };
    switch (ajaxOptions.type) {
      case 'GET':
      case undefined:
        {
          request.send();
          break;
        }
      case 'PUT':
      case 'PATCH':
      case 'POST':
        {
          if (!ajaxOptions.contentType) {
            request.setRequestHeader('Content-type', 'application/json');
          }
          request.send(ajaxOptions.data);
          break;
        }
      default:
        {
          console.error(`Unsupported custom-quick-fetch method "${ajaxOptions.type}", skipping custom-quick-fetch for ${ajaxOptions.url}`);
          return;
        }
    }
  }

  /*
   * TODO: This is a stopgap for the eu hublet until a better URL schema is determined.
   * This is a blocker for completing hublets work.
   */
  const knownQaDomainPieces = ['getsidekickqa', 'hubspotqa', 'hubspotfreeqa', 'hubspotemailqa', 'hubspotstarterqa'];
  const checkIsQa = (hostname = document.location.hostname) => {
    if (knownQaDomainPieces.find(piece => hostname.includes(piece)) !== undefined) {
      return 'qa';
    }
    return '';
  };
  const checkHublet = (hostname = document.location.hostname) => {
    if (hostname.includes('-eu1.')) {
      return '-eu1';
    }
    return '';
  };
  function getApiUrl(endpoint) {
    return `https://api${checkHublet()}.hubspot${checkIsQa()}.com${endpoint}`;
  }
  window.unsubscribeQuickFetch = {
    clearAllRequests,
    getApiUrl,
    getRequestStateByName,
    makeEarlyRequest,
    removeEarlyRequest
  };
})();